<h6 class="mb-0 text-uppercase">Seller List</h6>
<hr />

<mat-card>
  <mat-card-content>

    <!-- Filter Input -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search Seller...">
    </mat-form-field>

    <div class="sorting-table">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
          <td mat-cell *matCellDef="let seller"> {{ seller.id }} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let seller"> {{ seller.name }} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
          <td mat-cell *matCellDef="let seller"> {{ seller.email }} </td>
        </ng-container>

        <!-- Active Status Column -->
        <ng-container matColumnDef="isActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let seller">
            <mat-slide-toggle [(ngModel)]="seller.isActive" (change)="toggleStatus(seller)">
              {{ seller.isActive ? 'Active' : 'Inactive' }}
            </mat-slide-toggle>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let seller">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editSeller(seller)">
                <mat-icon>edit</mat-icon> Edit
              </button>
              <button mat-menu-item (click)="deleteSeller(seller.id)">
                <mat-icon>delete</mat-icon> Delete
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <!-- Table Headers & Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- No Data Message -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="5">No sellers found</td>
        </tr>

      </table>

      <!-- Paginator -->
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons></mat-paginator>
    </div>

  </mat-card-content>
</mat-card>
